//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectObjectList.js";
import "../GeometricUtilities/GeometricUtilities.ProjectionOptions.js";
import "../no/RegionPointList.js";
import "../no/SelectBodyList.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"AllowTargetEdgesAsToolObjects",1,0],[0,"ApplyToCopyOfSheets",1,0],[1,"BoundaryObjects",0,"SelectObjectList",0],[0,"ExtendBoundaryObject",1,0],[0,"ImprintBothSide",1,0],[0,"KeepDiscardMethod",1,0],[0,"OutputExactGeometry",1,0],[1,"ProjectionDirection",0,"GeometricUtilities.ProjectionOptions",0],[1,"Regions",0,"RegionPointList",0],[1,"TargetBodies",0,"SelectBodyList",0],[0,"Tolerance",1,0]],[],[]];
SPLM.Features.TrimSheetBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.TrimSheetBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.TrimSheetBuilder.KeepDiscardOption = Object.freeze({
    "Keep" : "Keep", "Discard" : "Discard"});

export default SPLM;